import { HiOutlineChevronRight } from 'react-icons/hi';

import useRoundFieldsTest from '@core/hooks/RoundFieldsTest/useRoundFieldsTest';
import cn from '@core/utils/classNames';

import { type ContinueButton } from '../continueButtonsTypeDictionary';
import styles from './SubmitButton.module.css';

const SubmitButton: ContinueButton = ({ text, disabled, buttonRef, onClick = () => {} }) => {
  const { lgRounded } = useRoundFieldsTest();
  return (
    <>
      <button
        type="button"
        data-testid="continue"
        className={cn(styles.submitButton, lgRounded)}
        disabled={disabled}
        onClick={onClick}
        ref={buttonRef}
      >
        {text}
        <HiOutlineChevronRight />
      </button>
    </>
  );
};

export default SubmitButton;
